export default "__VITE_ASSET__BflygWhQ__"